var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrewdriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.414 2.51594L21.434 0.535939C21.1807 0.282255 20.8306 0.149638 20.4728 0.171833C20.115 0.194028 19.784 0.368895 19.564 0.651939L17.186 3.70894C16.7562 4.26267 16.6477 5.00097 16.9 5.65494L11.649 10.8999C11.5516 10.9978 11.5516 11.156 11.649 11.2539L12.709 12.3149C12.7559 12.362 12.8196 12.3884 12.886 12.3884C12.9524 12.3884 13.0161 12.362 13.063 12.3149L18.32 7.06094C18.5422 7.14282 18.7772 7.18479 19.014 7.18494C19.4589 7.18597 19.8913 7.03773 20.242 6.76394L23.3 4.38694C23.5829 4.16671 23.7578 3.83566 23.7802 3.47781C23.8025 3.11996 23.6703 2.7697 23.417 2.51594H23.414Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42749 9.85132C7.77713 9.75977 8.14893 9.86414 8.39999 10.124L14.052 15.781C14.431 16.1735 14.4256 16.7971 14.0398 17.1829C13.6541 17.5686 13.0304 17.574 12.638 17.1951L12.173 16.73L6.04199 22.86C5.41797 23.4845 4.57086 23.8347 3.68802 23.833C1.79382 23.7847 0.269409 22.2612 0.220001 20.3671C0.218872 19.4829 0.571808 18.6351 1.20001 18.0131L7.33099 11.8821L6.98599 11.5381C6.72604 11.287 6.6218 10.9152 6.71332 10.5656C6.80481 10.2159 7.07788 9.94287 7.42749 9.85132ZM2.92001 20.342L9.35703 13.9091L8.64502 13.2001L2.21301 19.6351C2.01782 19.8303 2.01782 20.1469 2.21301 20.342C2.40961 20.5341 2.72342 20.5341 2.92001 20.342Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrewdriver);
export default __webpack_public_path__ + "static/media/screwdriver.8f9eb170.svg";
export { ForwardRef as ReactComponent };